import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { TimetableDetailEntity, TimetableDetailResponse, deserializeTimetableDetail } from 'src/entities/Timetable.entity';

import { TIMETABLES_QUERY_KEY } from './useTimetables.query';

export const TIMETABLES_BASE_PATH = '/api/v5/master/timetables';
/** 一覧のキー [TIMETABLES_QUERY_KEY] の下に置き、一覧の invalidate で詳細も捨てる */
export const timetableQueryKey = (id: number) => [TIMETABLES_QUERY_KEY, 'detail', id] as const;

export const useTimetableQuery = (id: number | null) => useQuery<TimetableDetailEntity, Error>({
  queryKey: timetableQueryKey(id ?? 0),
  queryFn: async () => deserializeTimetableDetail((await axios.get<TimetableDetailResponse>(`${TIMETABLES_BASE_PATH}/${id}`)).data),
  enabled: id != null,
});
